import React from 'react';
import PropTypes from 'prop-types';

import Metrics from '@spotahome/soyuz-tracking';
import { Button } from '@spotahome/ui-library';

import {
  getActiveFilters,
  groupFilterCategory
} from '@spotahome/marketplace-common/src/utils/filters';

import { filtersShape } from '../../shapes/filters';

import './RemoveFilters.scss';

const RemoveFilters = ({ onFiltersUpdate, filters }) => {
  const renderRemoveFilterButton = (id, title, defaultValues) => {
    return (
      <Button
        color="select"
        alt
        size="small"
        onClick={() => {
          Metrics.ga.sendEvent('Search', `remove-${id}`, 'remove-filter');
          onFiltersUpdate(defaultValues);
        }}
        className="search-title__clear-filter-button"
      >
        {title}
      </Button>
    );
  };

  const activeFilters = getActiveFilters(filters);

  const defaultFiltersList = [];

  activeFilters.forEach(element => {
    const { 0: filterTitle } = element;

    const groupedRemoveFilter = groupFilterCategory(filterTitle);
    const { id } = groupedRemoveFilter;

    const filterAlreadyExists = defaultFiltersList.find(
      defaultFilter => defaultFilter.id === id
    );

    if (!filterAlreadyExists) {
      defaultFiltersList.push(groupedRemoveFilter);
    }
  });

  defaultFiltersList.sort((a, b) =>
    a?.appearanceOrder < b?.appearanceOrder ? -1 : 1
  );

  return defaultFiltersList?.length ? (
    <div className="remove-filters">
      {defaultFiltersList?.map(filter => {
        const { id, title, defaultValues } = filter;
        return renderRemoveFilterButton(id, title, defaultValues);
      })}
    </div>
  ) : (
    ''
  );
};

RemoveFilters.propTypes = {
  filters: filtersShape,
  onFiltersUpdate: PropTypes.func.isRequired
};

RemoveFilters.defaultProps = {
  filters: {}
};

export default RemoveFilters;
